import React from 'react'
import Icon from '@material-ui/core/Icon';
import './TwoOption.css'

export default class TwoOption extends React.PureComponent {
  constructor(props) {
    super(props)
    this.setActive = this.setActive.bind(this)
  }

  // TODO find a better way. dont use DOM. use refs.
  componentDidMount() {
    const { options } = this.props.widget.content
    document.getElementById(options[1].active).classList.add('hide')
    document.getElementById(`option-${options[0].active}`).classList.add('active')
  }

  // TODO find a better way. dont use DOM. use refs.
  setActive(active) {
    const { options } = this.props.widget.content

    // hide both work profile sections at first + remove active class from both cards
    options.forEach((element, idx) => {
      document.getElementById(element.active).classList.add('hide')
      document.querySelectorAll('.option-card')[idx].classList.remove('active')
    });

    // set show work details and active on card as appropriate
    document.getElementById(active).classList.remove('hide')
    document.getElementById(`option-${active}`).classList.add('active')

  }
  renderOptions ({ options }) {
    return (
      <div className="two-options-cards">
        { options.map((option, idx) => {
          const { img, text, active } = option
          return (
            <div key={idx} className='option-card' id={`option-${active}`} onClick={() => this.setActive(active)}>
              <img src={img} alt={text} />
              <span>{text}</span>
            </div>    
          )
        })}
      </div>
    )
  }

  render () {
    const { content } = this.props.widget
    const { textTop, textBottom, options } = content
    return (
      <div className='two-options'>
        <span className="textTop">{ textTop }</span>
          {this.renderOptions({ options })}
        <h3>{ textBottom }</h3>
        <div className='down-arrow'> <Icon>keyboard_arrow_down</Icon> </div>
      </div>
    )
  }
}